module.exports = __webpack_public_path__ + "img/exterior_10.fcd57e28.jpg";